import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { LIGHT_BLUE_COLOR } from '../../styles/colors';
import { OpenModalContainer } from '../openModalContainer';
const HTML_RENDER_CSS = css `
  padding-bottom: 10px;
`;
const LABEL_CSS = css `
  color: ${LIGHT_BLUE_COLOR};
`;
const TEXT_CSS = css `
  white-space: pre-wrap;
  border: 1px solid white;
  border-radius: 10px;
  padding: 10px;
  font-family: monospace;
  font-size: 80%;
  background-color: rgba(0, 0, 0, 0.2);
`;
export const TestEmailDetailsModal = ({ emailMessage, onClose }) => {
    const { html, text } = emailMessage;
    return (_jsx(OpenModalContainer, { title: 'Test Email Details', onClose: onClose, maxWidth: 'md', children: _jsxs(DialogContent, { children: [_jsxs(DialogContentText, { children: [_jsx("span", { css: LABEL_CSS, children: "Subject:" }), " ", emailMessage.subject] }), _jsxs(DialogContentText, { children: [_jsx("span", { css: LABEL_CSS, children: "To:" }), " ", emailMessage.to.join(', ')] }), html ? (_jsxs(DialogContentText, { component: 'div', children: [_jsx("div", { css: LABEL_CSS, children: "HTML:" }), _jsx("div", { "aria-label": 'html-render', dangerouslySetInnerHTML: { __html: html }, css: HTML_RENDER_CSS }), _jsx("div", { css: TEXT_CSS, "aria-label": 'html-body', children: html })] })) : null, text ? (_jsxs(DialogContentText, { component: 'div', children: [_jsx("div", { css: LABEL_CSS, children: "Text:" }), _jsx("div", { css: TEXT_CSS, "aria-label": 'text-body', children: text })] })) : null] }) }));
};
